import {FC} from "react";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {BroadcastDetails} from "../../../lib/src/api/repositories/broadcast-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const PublishBroadcastModal: FC<{ broadcast: Broadcast&BroadcastDetails, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const {showToast} = useToasts()

  const submit = async () => {
    await broadcasts.sendBroadcast(props.broadcast.id).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het versturen.')
    })
    props.onFinished()
  }

  return <div>
    <div>Weet je zeker dat je het volgende wilt publiceren?</div>
    <div className={'font-semibold'}>&middot; {props.broadcast.subject}</div>
    <div>Deze wordt verstuurd naar:</div>
    <div className={'font-semibold'}>&middot; {props.broadcast.unpublished_user_subs.length} {props.broadcast.target_type === 'clients' ? 'Cliënten' : 'Medewerkers'}</div>
    <ModalFooter text={'Versturen'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}